import { FormattedMessage } from 'react-intl';
import styled, { type CSSProperties } from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandM } from '@sorare/core/src/atoms/typography';
import { ANY_SPORT_MARKET_LEGACY_PACKS } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { glossary } from '@sorare/core/src/lib/glossary';

import legacyPacksImage from './assets/legacy-packs.webp';

const Root = styled(ButtonBase)`
  position: relative;
  isolation: isolate;
  padding: var(--quadruple-unit) var(--triple-unit) 0;
  background:
    linear-gradient(to bottom, transparent 77%, var(--c-black) 100%),
    var(--c-background-image) bottom center/100% 100% no-repeat;
  border-radius: var(--double-unit);
`;

const PackImg = styled.img`
  object-fit: contain;
  width: 80%;
`;

type Props = {
  bgImage: string;
};
export const LegacyPacksTile = ({ bgImage }: Props) => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Root
      style={
        {
          '--c-background-image': `url(${bgImage})`,
        } as CSSProperties
      }
      to={`${generateSportContextPath(ANY_SPORT_MARKET_LEGACY_PACKS)}`}
    >
      <Vertical gap={3} center>
        <BrandM>
          <FormattedMessage {...glossary.legacyPacks} />
        </BrandM>

        <PackImg src={legacyPacksImage || ''} alt="Legacy Packs" />
      </Vertical>
    </Root>
  );
};
